<div #photoViewer
     class="viewer-360"
     *ngIf="isWebGLAvailable">
    <div #loader class="loader">
        <span>Loading 360-degree photo...</span>
    </div>
</div>
<div class="not-available"
     *ngIf="!isWebGLAvailable">
     <span>360-degree photo can not be displayed on your device</span>
</div>
